export function getPublicStopIdentifier(stopOrId, fallbackStopId) {
  const stopLike =
    stopOrId && typeof stopOrId === "object" ? stopOrId : undefined;
  const stopCode = String(
    stopLike?.stop_code ?? stopLike?.stopCode ?? "",
  ).trim();

  if (stopCode) {
    return stopCode;
  }

  const stopId = stopLike
    ? stopLike?.stop_id || stopLike?.id || fallbackStopId
    : stopOrId || fallbackStopId;
  const normalized = String(stopId || "").trim();

  if (!normalized) {
    return "";
  }

  const hashedStopIdMatch = normalized.match(/^([^-]+)-[0-9a-f]{6,}$/i);
  if (hashedStopIdMatch) {
    return hashedStopIdMatch[1];
  }

  return normalized;
}

export function getStopCodeDisplay(stopOrId) {
  const stopLike =
    stopOrId && typeof stopOrId === "object" ? stopOrId : undefined;
  return String(stopLike?.stop_code ?? stopLike?.stopCode ?? "").trim();
}
